import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import ProductQuotationsChart from '../components/ProductQuotationsChart';
import api from '../services/api';

/**
 * Shows the monthly quotation chart and the system status.
 */
function Dashboard() {
  const { user } = useAuth();
  const [quotationSeries, setQuotationSeries] = useState(null);
  const [quotationLoading, setQuotationLoading] = useState(true);
  const [quotationError, setQuotationError] = useState(false);

  useEffect(() => {
    loadQuotationSeries();
  }, [user?.role]);

  /**
   * Loads the monthly quotation values of the three products.
   */
  const loadQuotationSeries = async () => {
    try {
      setQuotationError(false);
      const response = await api.get('/dashboard/quotations');
      setQuotationSeries(response.data);
    } catch (error) {
      console.error('Erro ao carregar cotações do dashboard:', error);
      setQuotationError(true);
    } finally {
      setQuotationLoading(false);
    }
  };

  return (
    <Layout>
      <ProductQuotationsChart
        series={quotationSeries}
        loading={quotationLoading}
        error={quotationError}
      />

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Status do Sistema</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex items-center space-x-3">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span className="text-sm text-gray-700">Backend API</span>
            <span className="text-xs text-gray-500">Online</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span className="text-sm text-gray-700">Banco de Dados</span>
            <span className="text-xs text-gray-500">Conectado</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span className="text-sm text-gray-700">Cache Redis</span>
            <span className="text-xs text-gray-500">Ativo</span>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;
